import { combineReducers } from 'redux';
import fields from './fields/reducer';
import reportFolders from './reportFolders/reducer';
import reports from './reports/reducer';

export default combineReducers({
  fields,
  reportFolders,
  reports
});



// WEBPACK FOOTER //
// ./src/store/metaData/reducer.js